export default __webpack_public_path__ + "static/media/logo.09434b3a.png";